import React from "react";
import Project from "../Component/Project";

function Projects() {
  return (
    <div className="resume-box">
      <Project />
    </div>
  );
}
export default Projects;
